/**
 * Symbols -> galmoji.
 *
 * Ported verbatim from galjp v4 (lib/chars/other.json). The values are intentionally
 * unchanged — see docs/DESIGN.md premise 3. Regenerate with:
 *   npm run data:port
 */
export const symbol: Readonly<Record<string, string>> = {
  '!': '.ᐟ',
  '！': '.ᐟ',
};
